import { CircularProgress, DialogActions } from '@mui/material'
// import Button from '@mui/material/Button'
import { Button } from '@/@core/components/mui/Button'
import { useTranslator } from '@/hooks'

interface ForgotPasswordFormStepActionProps {
  handleBack: () => void
  handleNext: () => void
  handleSubmit?: () => void
  steps: Array<{ labelPC: string; labelMB : string }>
  activeStep: number
  handleClose: () => void
  loadingForm: boolean
  isStepValid: boolean
}

export default function ForgotPasswordFormStepAction({
  handleBack,
  handleNext,
  activeStep,
  steps,
  loadingForm,
  isStepValid
}: ForgotPasswordFormStepActionProps) {
  const { __ } = useTranslator()

  return (
    <DialogActions
      classes={{
        root: [1, 3].includes(activeStep)
          ? 'flex flex-col items-center justify-between px-0 gap-6'
          : activeStep === 2
            ? 'flex flex-col items-center justify-between px-0 gap-6'
            : 'flex flex-col items-center justify-between px-0 gap-6'
      }}
    >

      {activeStep < steps.length - 1 ? (
        <Button
          variant='contained'
          onClick={handleNext}
          className='gap-2 rounded-full w-full py-[15px]'
          disabled={!isStepValid}
          sx={{
            height: 48
          }}
        >
          <div className='text-[#fff] text-[17px] font-semibold flex items-center'>
            {activeStep === 0 && (
              <span>
                {__('Send Reset Link')}
              </span>
            )}
            {activeStep === 1 && (
              <span>

                {__('Verify my account')}
              </span>
            )}
            {loadingForm && (
              <CircularProgress color='info' className='ml-2' size={20} />
            )}
          </div>
        </Button>
      ) : (
        <Button
          type='submit'
          variant='contained'
          className='gap-2 rounded-full w-full py-[15px]'
          sx={{
            height: 48
          }}
        >
          <div className='text-[#fff] text-[17px] font-semibold flex items-center gap-2'>
            {__('Set new password')}
            {loadingForm && (
              <CircularProgress color='info' className='ml-2' size={20} />
            )}
          </div>
        </Button>
      )}
      {activeStep > 0 && activeStep < 2 && (
        <Button
          variant='contained'
          className='bg-[#6F83F629] text-[#6F83F6] text-[15px] gap-2 rounded-full w-full py-[15px] ml-0'
          startIcon={<i className='tabler-arrow-left' />}
          onClick={handleBack}
          sx={{
            height: 48,
            '&.MuiButtonBase-root ': {
              boxShadow: 'none'
            }
          }}
        >
          {__('Previous')}
        </Button>
      )}
    </DialogActions>
  )
}
